import React from 'react'
import PropTypes from 'prop-types'

function Divider() {
  return <span className='result__divider'>/</span>
}

function getGainedPointsClasses(gainedPoints) {
  if (gainedPoints < 0) return 'points-gained--failed'
  if (gainedPoints === 0) return 'points-gained--zero'
  return 'points-gained--completed'
}

let QuizPointResult = ({ gainedPoints, pointsToPass, pointsSummary, className }) => (
  <span className={className}>
    <span className={`block--weight-bold ${getGainedPointsClasses(gainedPoints)}`}>{gainedPoints}</span>
    <Divider />
    <span className='block--weight-bold points--to-pass'>{pointsToPass}</span>
    <Divider />
    <span className='block--weight-bold points--total'>{pointsSummary}</span>
  </span>
)

QuizPointResult.propTypes = {
  gainedPoints: PropTypes.number.isRequired,
  pointsToPass: PropTypes.number.isRequired,
  totalPoints: PropTypes.number,
}
QuizPointResult = React.memo(QuizPointResult)
QuizPointResult.displayName = 'QuizPointResult'

export default QuizPointResult
